/**
 * @deprecated `Avatar` is deprecated please use `AvatarView` instead
 */
var AvatarType;
(function (AvatarType) {
  AvatarType["THUMBNAIL"] = "thumbnail";
  AvatarType["ICON"] = "icon";
  AvatarType["EMOJI"] = "emoji";
  AvatarType["INITIALS"] = "initials";
})(AvatarType || (AvatarType = {}));

export { AvatarType };
//# sourceMappingURL=avatarTypes.mjs.map
